import { AppState } from 'reducers';

export const isMenuOpen = (state: AppState) => state.menu.open;
